import type { FormState } from "react-hook-form";
import type { Shipment } from "@api/graphql/generated/generated-types";
import { makeTimeOnDateInCourierTZ } from "@src/common/utils/timezoneConverters";
import { sortTasksBySequenceNumber } from "@src/shipments/utils/sortTasksBySequenceNumber";
import type { ManualArrivalFormData } from "../types";

export function formatManualArrivalFormToTaskArrivalOverrides(
  sortedStops: NonNullable<Shipment["stops"]>,
  formData: ManualArrivalFormData,
  dirtyFields: FormState<ManualArrivalFormData>["dirtyFields"],
): { taskId: string; arrivalOverride: number }[] {
  const overrides: { taskId: string; arrivalOverride: number }[] = [];
  sortedStops.forEach((stop) => {
    sortTasksBySequenceNumber(stop.tasks).forEach((task) => {
      const taskDirty = dirtyFields[task.id];
      if (!taskDirty?.date && !taskDirty?.time) return;
      const fields = formData[task.id];
      if (!fields?.date || !fields?.time) return;
      const unix = makeTimeOnDateInCourierTZ(fields.time, fields.date);
      if (unix === undefined) return;
      overrides.push({ taskId: task.id, arrivalOverride: unix });
    });
  });
  return overrides;
}
